document.addEventListener('click', function (event) {
  var button = event.target.closest('.quantity-stepper__btn');
  if (!button) return;

  var wrapper = button.closest('.quantity-stepper');
  var input = wrapper && wrapper.querySelector('.quantity-stepper__input');
  if (!input) return;

  var min = parseInt(input.min, 10) || 1;
  var value = parseInt(input.value, 10) || min;

  if (button.classList.contains('quantity-stepper__btn--plus')) {
    value += 1;
  } else {
    value = Math.max(min, value - 1);
  }

  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
